import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
export const getDomain = () => {
  const {
    hostname
  } = window.location;
  return hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1);
};
export function useCookie({
  name,
  defaultValue,
  expires: expiresArg = 365
}) {
  const expires = expiresArg === 'session' ? undefined : expiresArg;
  const {
    protocol
  } = new URL(window.location.href);
  function getCookie() {
    const item = Cookies.get(name);
    return item ? JSON.parse(item) : null;
  }
  const [value, setValue] = useState(() => {
    var _getCookie;
    return (_getCookie = getCookie()) !== null && _getCookie !== void 0 ? _getCookie : defaultValue;
  });
  useEffect(() => {
    function setCookie(val) {
      Cookies.set(name, JSON.stringify(val), {
        domain: getDomain(),
        expires,
        secure: protocol.startsWith('https')
      });
    }
    setCookie(value);
  }, [expires, name, protocol, value]);
  return [value, setValue];
}